export default __webpack_public_path__ + "static/media/Plantilla-multiple-destinatario.59ac631e.xlsx";